import { Amplify, ResourcesConfig } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { env } from 'env';

const {
  // @ts-ignore
  REACT_APP_COGNITO_CLIENT_ID,
  // @ts-ignore
  REACT_APP_COGNITO_USERPOOL_ID,
  // @ts-ignore
  REACT_APP_COGNITO_DOMAIN,
} = env;

const authConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: REACT_APP_COGNITO_CLIENT_ID,
      userPoolId: REACT_APP_COGNITO_USERPOOL_ID,
      loginWith: {
        oauth: {
          domain: REACT_APP_COGNITO_DOMAIN,
          scopes: ['openid'],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code',
        },
      },
    },
  },
};

export const configureAuth = () => {
  cognitoUserPoolsTokenProvider.setAuthConfig({
    Cognito: {
      userPoolClientId: REACT_APP_COGNITO_CLIENT_ID,
      userPoolId: REACT_APP_COGNITO_USERPOOL_ID,
      loginWith: {
        oauth: {
          domain: REACT_APP_COGNITO_DOMAIN,
          scopes: ['openid'],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code',
        },
      },
    },
  });

  Amplify.configure(authConfig);
};
